import httpClient from './httpClient';

export const PRODUCTS_ENDPOINT = '/backoffice/products';

export const getProductsAPI = (params = {}) => httpClient.get(PRODUCTS_ENDPOINT, { params });
export const getProductAPI = (id) => httpClient.get(`${PRODUCTS_ENDPOINT}/${id}`);
export const updateProductAPI = (id, params) => httpClient.put(`${PRODUCTS_ENDPOINT}/${id}`, params);
export const createProductRemarkAPI = (id, params = {}) => httpClient.post(`${PRODUCTS_ENDPOINT}/${id}/product-remarks`, params);
